// Day flags registry (sql/094 day_flags — moves-architecture.md "calendar
// gaps"). 'full' = a lead said stop selling this day (the hand-typed
// BOOKED marker from the Google calendar); 'closed' = holiday / break.
// The store publishes the list here so every DatePicker can shade days
// without threading a prop through 23 call sites. Read-only for pickers;
// Capacity and Settings own the edits (store.saveDayFlag).
let registry = new Map();
const listeners = new Set();
export function setDayFlagsRegistry(list) {
    registry = new Map((list || []).map(f => [f.date, f]));
    listeners.forEach(fn => { try { fn(registry); } catch { /* ignore */ } });
}
export const getDayFlag = (ymd) => registry.get(ymd) || null;
export const subscribeDayFlags = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const DAY_FLAG_LABEL = { full: 'Full — no more jobs', closed: 'Closed' };
